//способ оплаты
export const accountingTypeList = [
    {value: 1, label: "Готівковий"},
    {value: 2, label: "Безготівковий (оплата на РР)"}
]
//способ доставки
export const shippingMethodList = [
    {value: 4, label: "Доставка за адресою"},
    {value: 1, label: "Самовивіз"},
    {value: 2, label: "Перевізник (Делівері, Нова пошта)"},
    {value: 3, label: "Найманий транспорт"}
    //{value: 3, label: "Наемный транспорт"},
    //{value: 4, label: "Доставка по адресу"}
]
//условия оплаты
export const paymentTypeList = [
    {value: 1, label: "Відтермінування платежу"},
    {value: 4, label: "Передплата"}
]

export const getAccountingTypeList = (okpo) =>{
    if(okpo === '00000000' || okpo === '000000000' || okpo === '0000000000')
    {
        return [
            {Value: 1, Label: "Готівковий"}
        ]
    }

    return [
        {Value: 1, Label: "Готівковий"},
        {Value: 2, Label: "Безготівковий (оплата на РР)"}
    ]
}

export const MarketingStockTypesEnum = {
    default : 100000001,
    calculating: 100000002
}

export const ProductBalance = Object.freeze({
    InStock: 'IN_STOCK',
    Ends: 'ENDS',
    OutOfStock: 'OUT_OF_STOCK',
  });